module.exports = __webpack_public_path__ + "01f43047/img/note-list-icon.961c1485.svg";